var exports = {
  "MK": "TkxVQXl",
  "AS": "X29MZmJ",
  "me": "WTlwM2R",
};

module.exports = exports;
